// src/services/api.ts
import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 🔒 Interceptador JWT
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

//import axios from "axios";

//export const api = axios.create({
 // baseURL: "https://localhost:7164/api",
 // headers: {
//    "Content-Type": "application/json",
 // },
//});

// 🔒 Interceptador para adicionar token a cada requisição
//api.interceptors.request.use(
 // (config) => {
   // const token = localStorage.getItem("token");
   // if (token) {
   //   config.headers.Authorization = `Bearer ${token}`;
   // }
  //  return config;
 // },
 // (error) => Promise.reject(error)
//);
